<div class="rsm-topbar">

  <div class="topbar-right">
    <div class="global-search-container" [class.is-focused]="searchFocused" (click)="onSearchFocus()">
      <div class="global-search">
        <button class="context-selector" [matMenuTriggerFor]="contextMenu" *ngIf="searchFocused">
          <span>{{ selectedSearchContext }}</span>
          <i class="fa-solid fa-angle-down"></i>
        </button>
        <mat-menu #contextMenu="matMenu" class="custom-dropdown custom-dropdown--context">
          <button *ngFor="let context of searchContexts" mat-menu-item (click)="onSearchContextChange(context)">
            {{ context }}
          </button>
        </mat-menu>

        <div class="search-input-wrapper">
          <i class="fa-solid fa-search search-icon"></i>
          <input type="text" placeholder="Busca global..." [(ngModel)]="globalSearchTerm"
            (ngModelChange)="onSearchTermChange($event)" (keyup.enter)="onSearchSubmit()" (focus)="onSearchFocus()"
            (blur)="onSearchBlur()" />
          <button class="clear-search" *ngIf="globalSearchTerm" (click)="clearSearch($event)">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <!-- Dropdown de resultados da busca -->
      <div class="search-results-dropdown" *ngIf="searchFocused && globalSearchTerm">
        <ng-container *ngIf="groupedSearchResults.length; else noResults">
          <div class="results-group" *ngFor="let group of groupedSearchResults; let i = index" [class.mt-3]="i > 0">
            <div class="group-title">{{ group.category }}</div>
            <button type="button" class="result-item" *ngFor="let item of group.items"
              (mousedown)="onSearchResultClick(item.route, $event)">
              <i [class]="item.iconClass + ' ' + item.colorClass"></i>
              <span>{{ item.title }}</span>
            </button>
          </div>

          <div class="results-summary">
            {{ totalSearchResults }} {{ totalSearchResults === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
          </div>
        </ng-container>
        <ng-template #noResults>
          <div class="results-group">
            <div class="group-title">Sem resultados</div>
            <div class="result-item">
              <i class="fa-solid fa-circle-info text-gray"></i>
              <span>Nenhum registro encontrado para "{{ globalSearchTerm }}"</span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <button class="pill-btn company-pill select-company-btn" [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpened()">
      <i class="fa-solid fa-briefcase"></i>
      <span class="name">{{ currentCompanyName }}</span>
      <i class="fa-solid fa-angle-down"></i>
    </button>

    <mat-menu #menu="matMenu" class="custom-dropdown company-switcher-menu">

      <!-- ① Empresa ativa: fixa no topo, fora do scroll -->
      <div class="menu-btn company-active-item" *ngIf="activeCompanyOption">
        <div class="company-option is-active">
          <div class="company-option__check">
            <i class="fa fa-check"></i>
          </div>
          <div class="company-option__body">
            <div class="company-option__name">{{ activeCompanyOption.name }}</div>
            <div class="company-option__meta">
              <span class="company-option__plan p-color">
                Plano ativo: <b>{{ activeCompanyOption.planName || '-' }}</b>
              </span>
              <span class="company-option__edit p-color">
                <i class="fa fa-edit"></i>
                <span class="company-option__edit-text company-option__edit-text--default">Alterar Plano</span>
                <span class="company-option__edit-text company-option__edit-text--hover">Abrir Suporte</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- ② Demais empresas: scroll próprio, altura máxima -->
      <div class="company-list-scroll" *ngIf="inactiveCompanyOptions.length > 0">
        <div class="menu-btn menu-btn--switchable" [class.is-disabled]="!company.planName && !isRootContext"
             *ngFor="let company of inactiveCompanyOptions"
             (click)="switchCompanyContext(company)">
          <div class="company-option">
            <div class="company-option__check is-hidden">
              <i class="fa fa-check"></i>
            </div>
            <div class="company-option__body">
              <div class="company-option__name">{{ company.name }}</div>
              <div class="company-option__meta">
                <span class="company-option__plan">
                  Plano ativo: <b>{{ company.planName || '-' }}</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
        ③ Emulação de produto: só a RSM (plano ROOT). Desativado a pedido —
        mantido comentado (não removido) pra reativar rápido se precisar.
        ROOT é neutro — não herda comportamento de produto nenhum. Este seletor
        era como a RSM declarava sob qual produto estava operando. Ficava
        visível o tempo todo de propósito: quem esquece que está emulando
        Politics lê errado tudo o que vê no painel.

      <div class="company-emulation" *ngIf="isRootContext && emulationAvailable"
           (click)="$event.stopPropagation()">
        <div class="custom-dropdown__divider" role="separator"></div>
        <div class="company-emulation__title">
          Operando como: <b>{{ emulatedProductLabel }}</b>
        </div>
        <div class="menu-btn menu-btn--switchable"
             *ngFor="let option of emulationOptions"
             (click)="setEmulatedProductType(option.code)">
          <div class="company-option">
            <div class="company-option__check"
                 [class.is-hidden]="option.code !== emulatedProductType">
              <i class="fa fa-check"></i>
            </div>
            <div class="company-option__body">
              <div class="company-option__name">{{ option.label }}</div>
            </div>
          </div>
        </div>
      </div>
      -->

      <!-- ④ Footer fixo: Adicionar + Sair — sempre visíveis, fora do scroll -->
      <div class="company-menu-footer">
        <div class="add-btn" (click)="goToNewCompany()">
          <span class="circle-icon"><i class="fa fa-plus"></i></span>
          <span class="add-text">Adicionar nova empresa</span>
        </div>
        <div class="custom-dropdown__divider" role="separator"></div>
        <div class="menu-action menu-action--danger" (click)="onLogout()">
          <span class="menu-action__icon menu-action__icon--danger">
            <i class="fa-solid fa-arrow-right-from-bracket"></i>
          </span>
          <span class="menu-action__label menu-action__label--danger">Sair</span>
        </div>
      </div>

    </mat-menu>
  </div>
</div>